import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("tv_admin_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const mediaUrl = (id) => `${API}/public/media/${id}`;

/* URL media pubblici: i percorsi "/api/..." (es. proxy immagini del gestionale)
   vanno prefissati con l'origine del backend; gli URL assoluti restano invariati.
   thumb=true inoltra ?thumb=1 per le miniature delle schede. */
export const publicMedia = (u, thumb = false) => {
    if (!u) return u;
    if (!u.startsWith("/api/")) return u;
    const url = `${process.env.REACT_APP_BACKEND_URL}${u}`;
    return thumb ? `${url}?thumb=1` : url;
};

export function apiError(e, fallback) {
    const detail = e?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (detail && typeof detail === "object" && detail.message) return detail.message;
    if (Array.isArray(detail)) return detail.map((x) => x?.msg || "").filter(Boolean).join(" ");
    return fallback;
}
